export default class InputError extends Error {
  constructor() {
    super("Invalid input");
  }
}
